import { render, staticRenderFns } from "./busMain.vue?vue&type=template&id=006eed1f&scoped=true&"
import script from "./busMain.vue?vue&type=script&lang=js&"
export * from "./busMain.vue?vue&type=script&lang=js&"
import style0 from "./busMain.vue?vue&type=style&index=0&id=006eed1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006eed1f",
  null
  
)

export default component.exports